import React, { useState, useEffect, useRef } from "react";
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import { UrlPath } from "../../../config/routeConfig";
import { TopBar } from "../../shared/topBar/TopBar";
import { useNavigate, useParams, useLocation } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { SBADropDown, SBAComboBox } from "../../UiComponents/SBADropDown";
import { getPortFolioListAction, getPortFolioCashAction, getPortFolioCreditFacilityAction, getPortFolioCashAccountAction } from "../../actions/portfolioAction";
import { getTransactionStatusAction } from "../../actions/transactionAction";
import { sbaAxios } from "../../utils/sbaAxios";
import { insertUpdateTransaction, getPortfolioDetailAPI, getPortfolioNonCashAccounts } from "../../../config/apiConfig";
import { SBDatePicker } from "../../UiComponents/SBDatePicker";
import { SBNotify } from "../../utils/sbNotify";
import { ToastContainer } from "react-toastify";
import { getTransactionByID, currencyFormatter, getPortfolioListByAssetAndTransType, gettransactionEditAccess } from "../utils";
import moment from "moment";
import { Link } from "react-router-dom";
import { ExchangeRateModal } from "../Components/ExchangeRateModal";
import { SBACurrencyInput } from "../../UiComponents/SBACurrencyInput";
export const AddToPortfolio = () => {
  
    const dispatch = useDispatch();
    const Gstate = useSelector((state) => state);
    const history = useNavigate();
    const params = useParams();
    const locationData = useLocation();
    const transactionId = parseInt(params.TransId) || 0;
    const objType = parseInt(params?.ObjectType);
    const [transactionData, setTransactionData] = useState(plainAddPortfoliodata);
    const iseditable = transactionId === 0 ? false :true ;
  
    const statusStore = Gstate.transaction.statusList || [];
    const portfolioList = Gstate.portfolio.portfolioList || [];
    const [FromAccount, setFromAccount] = useState([]);
    const ToAccount = Gstate.portfolio.TOCash || [];
    const [statusDS, setStatusDS] = useState(statusStore);
    const [portfolio, setPortfolio] = useState();
    const[transactionEditAccess,setTransactionEditAccess]=useState(false);
    const statusVal = { "TransStatus": transactionData.TradeStatusName, "TransStatusId": transactionData.TradeStatusId };
    const portfolioVal = { "PortfolioId": transactionData.PortfolioId, "PortfolioName": transactionData.PortfolioName }
    const selectedfromaccount = transactionData.ChildDetails.length > 0 ? { "AssetId": transactionData.ChildDetails[0].AssetId, "AssetName": transactionData.ChildDetails[0].AssetName } : ""
    const selectedtoaccount = { "AssetId": transactionData.AssetId, "AssetName": transactionData.AssetName }
    const [showModal, setShowModal] = useState(false);
    const cmtDataPT = {
        assetType: {
            CurrencyId: 0,
            CurrencyCode: ""
        },
        Asset: {},
        Portfolio: {},
        Status: {},
        amount: null,
        decription: '',
        releaseCommitment: false,
        Date: new Date(),
        ExchangeRate: null,
        LocalAmount: null,
    }


    const Level = objType == 1 ? [
        {
            BreadCrumb: "Transactions >",
            Routes: `${UrlPath.Transactions}${params.AssetId}`,
        },
        {
            BreadCrumb: "Add To Portfolio",
            Routes: `${UrlPath.AddToPortfolio}${params.AssetId}`,
        },
    ] : [
        {
            BreadCrumb: "Transactions >",
            Routes: `/${UrlPath.portfolioTransaction}${params.EntityId}`,
        },
        {
            BreadCrumb: "Add To Portfolio",
            Routes: `/${UrlPath.PortfolioAddToPortfolio}${params.EntityId}`,
        },
    ];

    useEffect(() => {
        document.title = "Transactions Add To Portfolio";
        setTransactionEditUserAccess();
        if (objType == 1) {
            setTransactionByID(transactionId);
          
            setTransactionByID(transactionId);
            getAccountList(params?.EntityId);
        }
        else if (params.ObjectType == 3) {
            setTransactionByID(transactionId);    
            setPortfolioByID(params?.EntityId);
            setTransactionByID(transactionId);
            getAccountList(params?.EntityId);
            dispatch(getPortFolioCashAccountAction(params?.EntityId));

        }
      
        dispatch(getPortFolioListAction(null));
        dispatch(getPortFolioCashAction());
        dispatch(getPortFolioCreditFacilityAction());
        dispatch(getTransactionStatusAction());
    }, []);

    useEffect(() => {
        setStatusDS(statusStore)
        setTransactionData(value => ({ ...value, Status: statusStore[2] }));
    }, [statusStore]);
 // User Access Rights
 const setTransactionEditUserAccess= async()=>
 {
     const access = await gettransactionEditAccess();
     setTransactionEditAccess(access);
 }

    const getAccountList = async (id) => {
      
        try {
            const list = await getPortfolioNonCashAccount(id);
            setFromAccount(list);
        }
        catch {
            setFromAccount([]);
        }
    }

    const setPortfolioByID = async (Id) => {
       
        try {
            const portfolio = await getPortfolioDetailsByID(Id);
            setTransactionData(value => ({ ...value, PortfolioId: portfolio?.PortfolioId, PortfolioName: portfolio?.PortfolioName }));
            setPortfolio(portfolio);
        }
        catch (e) {
            setTransactionData(value => ({ ...value, PortfolioId: 0, PortfolioName: '' }));
            setPortfolio({});
        }

    };

    const setTransactionByID = async (id) => {
        if (id > 0) {
            try {
                const details = await getTransactionByID(id);
                setTransactionData(details);
                setPortfolioByID(details.PortfolioId);
                dispatch(getPortFolioCashAccountAction(details?.PortfolioId));

            } catch (e) {
                setTransactionData(plainAddPortfoliodata);
            }
        }
        else {
            setTransactionData(plainAddPortfoliodata);
        }

    };
   
    const portfolioDDChng = (e) => {  
        if (e.value) {
            const portfolio = e.value;
            setPortfolioByID(e.value.PortfolioId);
            setTransactionData(value => ({ ...value, AssetId: 0, AssetName: '' }))
            getAccountList(e.value.PortfolioId);
            if (objType === 3) {
                history(`/${UrlPath.PortfolioAddToPortfolio}0/${e.value.PortfolioId}/3`);              
                setTransactionData((value) => {
                    const updatedChildDetails = [...value.ChildDetails];
                    const lastItemIndex = updatedChildDetails.length - 1;
                    if (lastItemIndex >= 0) {
                        updatedChildDetails[lastItemIndex] = {
                            ...updatedChildDetails[lastItemIndex],
                            AssetId: 0,
                            AssetName: ""
                        };
                    }
                    return {
                        ...value, ExchangeRate: "1.00", LocalAmount: 0, TransAmount: "0.00", TransDescription: "", TransDate: TransactionDate,   ChildDetails: updatedChildDetails };
                });
            }
           
            dispatch(getPortFolioCashAccountAction(e.value.PortfolioId));
        }
            
        
    };
    const statusDDChng = (e) => {
       
        if (e.value) {
            setTransactionData(value => ({ ...value, TradeStatusId: e.value.TransStatusId, TradeStatusName: e.value.TransStatus }));
        }
    };
    const udpateDate = (e) => {
        if (e) {
            setTransactionData(value => ({ ...value, TransDate: e.toISOString() }))
        }
    };
    
    const ToaccountChange = (e) => {
        if (e.value) {
            setTransactionData(value => ({
                ...value,
                AssetId: e.value.AssetId,
                AssetName: e.value.AssetName
            }));
        } else {
            // Handle null or undefined value
            console.error("Invalid value:", e.value);
        }
    };
    
    const fromaccountChange = (e) => {
        if (e.value) {
            setTransactionData((value) => {
                const updatedChildDetails = [...value.ChildDetails];
                const lastItemIndex = updatedChildDetails.length - 1;
                if (lastItemIndex >= 0) {
                    updatedChildDetails[lastItemIndex] = {
                        ...updatedChildDetails[lastItemIndex],
                        AssetId: e.value.AssetId,
                        AssetName: e.value.AssetName
                    };
                }
                return { ...value, ChildDetails: updatedChildDetails };
            });
        } else {
            console.error("Invalid value:", e.value);
        }
    };


    const exchangeRateChange=(e)=>
    {
    
      
     const parsedValue = parseFloat(e);
                                            setTransactionData(value => ({
                                                ...value,
                                                ExchangeRate: parsedValue,
                                                LocalAmount: transactionData?.TransAmount * parsedValue
                                            }));
                                        }

    const savePortfolio = () => {   
        let saveSuccess = true;
        const savedata = {
            "transId": transactionId,
            "portfolioId": transactionData.PortfolioId,
            "assetId": transactionData.AssetId,
            "shareClassId": 0,
            "assetLotId": 0,
            "accountIdToBalance":transactionData.ChildDetails[0].AssetId,
            "tradeStatusId": transactionData.TradeStatusId,
            "transTypeId": 9,
            "transDate": transactionData.TransDate,
            "transAmount": transactionData.TransAmount,
            "localAmount": transactionData.LocalAmount,
            "exchangeRateId": 0,
            "exchangeRate": transactionData.ExchangeRate,
            "allocationDate": "",
            "shares": 0,
            "nav": 0,
            "transDescription": transactionData.TransDescription ? transactionData.TransDescription:"",
            "initialAllocationDate":"",
            "isFullRedemption": false,
            "isInsurance": false,
            "isFee": false,
            "isShareBased": false,
            "isCommitmentRelease": false,
            "modifiedBy": 0,
            "childTrans": [{
                "transId":transactionId>0?transactionData.ChildDetails[0].TransId:0,
                "assetId": transactionData.ChildDetails[0].AssetId,
                "transTypeId": 9,
                "assetLotId": 0,
                "transDate": transactionData.TransDate,
                "transAmount": -(transactionData.TransAmount),
                "localAmount": transactionData.LocalAmount,
                "shares": 0,
                "transDescription": "",
            }]
        };

        if (!transactionData.TradeStatusName || transactionData.TradeStatusName === "") {
            SBNotify({ Msg: "Please Select Status ", type: "error" });
            saveSuccess = false;
        }
        else if (!transactionData.AssetName || transactionData.AssetName === "") {
            SBNotify({ Msg: "To Account is Required", type: "error" });
            saveSuccess = false;
        }
        else if (!transactionData.ChildDetails[0].AssetId || transactionData.ChildDetails[0].AssetId ===0) {
            SBNotify({ Msg: "From Account is Required", type: "error" });
            saveSuccess = false;
        }
        else if (!transactionData.PortfolioId || transactionData.PortfolioId === 0) {
            SBNotify({ Msg: "Portfolio is Required", type: "error" });
            saveSuccess = false;
        }
        else if (!transactionData.TransAmount) {

            SBNotify({ Msg: "Please Enter Amount", type: "error" });
            saveSuccess = false;
        }
        else if (transactionData.TransAmount <= 0) {
            SBNotify({ Msg: "Please Enter Amount", type: "error" });
            saveSuccess = false;
        }

        else if (!transactionData.TransDate) {
            SBNotify({ Msg: "Please Choose Transaction Date", type: "error" });
            saveSuccess = false;
        }
        if (saveSuccess) {
            sbaAxios({
                url: `${insertUpdateTransaction}`,
                method: "post",
                data: savedata,
            })
                .then((response) => {
                    if (response) {
                        SBNotify({
                            type: "success",
                            Msg: "portfolio added Successfully",
                        });
                        navigateBack();
                    } else {
                        SBNotify({
                            type: "error",
                            Msg: `Failed to Update`,
                        });
                    }
                })
                .catch(() => { });
        }
    }
    const navigateBack = () => {
        if (objType === 1)
            history(`${UrlPath.Transactions}${params.EntityId}`);
        if (objType === 3)
            history(`/${UrlPath.portfolioTransaction}${transactionData.PortfolioId}`);
    };

    const handleClick = () => {
        setShowModal(true);
       
    };

    const closeModal = () => {
        setShowModal(false);
    }

    return (
        <>
            <TopBar label={"Transactions"} />
            <div id="AddtoPorfolio" className="mainContentData">
                <BreadCrumbs Levels={Level} />
                <div className="asset-detail-screen p-3">
                    <div className="detail p-4">
                        <div className="col-lg-12 px-0">
                            <div className="row m-0">
                                <div className="row mb-4">
                                   <div className="col-md-4">
                                  
                                        <label className="mb-1 label">Status<span class="mandatory">*</span></label>
                                        <div>
                                            <SBADropDown
                                                className="w-75"
                                                data={statusDS}
                                                textField={"TransStatus"}
                                                valueField={"TransStatusId"}
                                                value={statusVal.TransStatus ? statusVal : statusDS[2]}
                                                onChange={statusDDChng}

                                            />
                                        </div>
                                    </div>


                                    <div className="col-md-4">
                                        <label className="mb-1 label">Portfolio<span class="mandatory">*</span></label>
                                        <div>
                                            <SBAComboBox
                                                className="w-75"
                                                data={portfolioList}
                                                textField="PortfolioName"
                                                valueField="PortfolioId"
                                                onChange={portfolioDDChng}
                                                value={portfolioVal}
                                                disabled={iseditable}
                                            />

                                        </div>
                                    </div>                    
                                </div>
                                <div className="row mb-4">
                                    
                                    <div className="col-md-4">
                                        <label className="mb-1 label">From Account<span class="mandatory">*</span></label>
                                        <div>
                                            <SBAComboBox
                                                className="w-75"
                                                data={FromAccount}
                                                textField={"AssetName"}
                                                valueField={"AssetId"}
                                                onChange={fromaccountChange}
                                                value={selectedfromaccount}

                                            />
                                        </div>
                                    </div>


                                    <div className="col-md-4">
                                        <label className="mb-1 label">To Account<span class="mandatory">*</span></label>
                                        <div>
                                            <SBAComboBox
                                                className="w-75"
                                                data={ToAccount}
                                                textField={"AssetName"}
                                                valueField={"AssetId"}
                                                value={selectedtoaccount}
                                                onChange={ToaccountChange}
                                            />
                                        </div>
                                    </div>
                                                                       
                                </div>

                                <div className="row mb-4">
                                    <div className="col-md-4">
                                        <div> <label className="mb-1 label"></label></div>
                                    <label className="mb-1 label">Transaction Date</label>
                                    <span class="mandatory">*</span>
                                    <div className="d-flex gap-2">
                                        <SBDatePicker className="w-75" value={transactionData.TransDate ? moment(transactionData.TransDate) : null} onChange={udpateDate} />
                                    </div>
                                    </div>

                                    <div className="col-md-4">
                                        <div><label className="mb-1 mt-2 label"><Link className="noUnderLine" onClick={handleClick}>USD</Link></label>
                                            </div>
                                        <label className="mb-1 label"> Amount<span class="mandatory">*</span></label>
                                        <div className="d-flex gap-2">
                                            <SBACurrencyInput
                                                className={"form-control w-75"}

                                                decimalsLimit={2}
                                                value={transactionData?.TransAmount ? transactionData?.TransAmount : null}
                                                onBlur={(e) => {
                                                    const parsedValue = parseFloat(e);
                                                    setTransactionData(value => ({
                                                        ...value,
                                                        TransAmount: parsedValue,
                                                        LocalAmount: parsedValue * transactionData?.ExchangeRate
                                                    }));
                                                }}
                                            />


                                           
                                        </div>



                                    </div>

                                    <div className="col-md-4">
                                        <div>
                                            <label className="mb-1 mt-2 label"><Link className="noUnderLine" onClick={handleClick}>{portfolio?.CurrencyCode}</Link><span style={{marginLeft:'8px'}}>({currencyFormatter(transactionData.ExchangeRate, 2)})</span> </label>
                                        </div>
                                        <label className="mb-1 label"> Local Amount</label>
                                        <div className="d-flex gap-2">
                                            <input className="form-control w-75" disabled={true} type="text" value={currencyFormatter(transactionData.LocalAmount, 2)} />

                                          
                                        </div>
                                    </div>

                                </div>

                            </div>
                            <div className="row m-0">                              
                                <div className="col-md-6">
                                    <label className="mb-1 label">Description</label>
                                    <div style={{ height: 100, width: "247%" }}>
                                        <textarea className="form-control w-75" type="text" value={transactionData?.TransDescription} onChange={(e) => { setTransactionData(value => ({ ...value, TransDescription: e.target.value })) }} />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            className="m-3 d-flex justify-content-end"
                            style={{ paddingBottom: "15px", paddingRight: "120px" }}
                        >
                           
                            <button className="s-sm-btn" onClick={() => { navigateBack() }}>
                                Cancel
              </button>
                            {transactionId !== 0 ? (
                                <button className="ms-2 p-sm-btn" disabled={!transactionEditAccess || transactionData.IsLocked} onClick={savePortfolio}>
                                    Save
                                </button>
                            ) : (
                                <button className="ms-2 p-sm-btn" disabled={false} onClick={savePortfolio}>
                                    Save
                                </button>
                            )}

                        </div>
                    </div>
                </div>
                
              
            </div>
            <ExchangeRateModal showModal={showModal} value={transactionData?.ExchangeRate} closeModal={()=>{setShowModal(false)}} onBlur={(e)=>exchangeRateChange(e)}></ExchangeRateModal>

            <ToastContainer></ToastContainer>
        </>
    );


}

const getPortfolioNonCashAccount = async (id) => {
    try {
        const response = await sbaAxios({ url: getPortfolioNonCashAccounts + '/' + id });
        return response;
    }
    catch (e) {
        return [];
    }
}

const getPortfolioDetailsByID = async (portfolioId) => {
    try {
        const response = await sbaAxios({ url: getPortfolioDetailAPI + portfolioId });
        return response;
    }
    catch (e) {
        console.log(e, 'Error Fetching the portfolio details')
        return {};
    };
};
var date = new Date();
var TransactionDate = new Date(date.getFullYear(), date.getMonth() + 1, 1);

const plainAddPortfoliodata = {
    "TransId": 0,
    "TransTypeId": 9,
    "TransTypeName": "Add to Portfolio",
    "PortfolioId": 0,
    "PortfolioName": "",
    "AssetId": 0,
    "AssetName": "",
    "ShareclassId": 0,
    "ShareClassName": "",
    "AssetLotId": 0,
    "accountIdToBalance":0,
    "AssetLotName": "",
    "TradeStatusId": 2,
    "TradeStatusName": "Executed",
    "TransDate": TransactionDate,
    "TransAmount": "0.00",
    "LocalAmount":"0.00",
    "CurrencyId": 0,
    "CurrencyCode": "",
    "ExchangeRateId": 0,
    "ExchangeRate": "1.00",
    "IsFullRedemption": false,
    "IsInsurance": false,
    "IsFee": false,
    "IsCommitmentRelease": false,
    "TransDescription": "",
    "ModifiedById": 0,
    "ModifiedByName": "",
    "ChildDetails": [{
        "TransId": 0,
        "TransTypeId": 9,
        "TransTypeName": "Add To Portfolio",
        "AssetId": 0,
        "AssetName": "",
        "ShareclassId": 0,
        "ShareClassName": "",
        "AssetLotId": 0,
        "AssetLotName": "",
        "TransDate": TransactionDate,
        "TransAmount": "0.00",
        "TransDescription": "",
        "ModifiedById": 0,
        "ModifiedByName": "0"
    }
    ]
}
